import { render, staticRenderFns } from "./bffollow.vue?vue&type=template&id=74080246&scoped=true&"
import script from "./bffollow.vue?vue&type=script&lang=js&"
export * from "./bffollow.vue?vue&type=script&lang=js&"
import style0 from "./bffollow.vue?vue&type=style&index=0&id=74080246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74080246",
  null
  
)

export default component.exports